import axios from 'axios';
import { IRequestConfig } from 'models/Axios';
import { HealthOperatorPropsData, HealthOperatorProps } from 'models/HealthOperator';

import Services from './index.service';
import { FilterDataSelectedCustomer } from 'utils/SelectedCustomerId';
import {
  TableFilterStateDataIntegrationProps
} from 'components/ReportDashDataIntegration/TableSearchDataIntegration/interface';

export default class HealthOperatorServices extends Services<HealthOperatorPropsData, HealthOperatorProps> {

  get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: TableFilterStateDataIntegrationProps
  ) => {

    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby || undefined;

    const orderCte = order?.split(' ').reverse();

    const config: IRequestConfig<HealthOperatorProps> = {
      url: '/health-operator/filters',
      params: {
        search: filter?.search,
        startPeriod: filter?.startPeriod,
        lastPeriod: filter?.lastPeriod,
        status: filter?.status,
        customerIds: FilterDataSelectedCustomer(),
        sortBy: orderCte?.[1] || "id",
        sortDirection: orderCte?.[0] || "desc",
        skip: (skip * top),
        top: top,
      },
    };

    return this.httpRequest(config);
  };

  getMessages = (
    currentPage?: number,
    pageSize?: number,
    healthOperatorId?: string
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;

    const config: IRequestConfig<HealthOperatorProps> = {
      url: `/health-operator/messages/${healthOperatorId}`,
      params: {
        sortBy: "eventDate",
        sortDirection: "desc",
        skip: (skip * top),
        top: top,
      },
    };

    return this.httpRequest(config);
  };

  async updateBuyOrder(
    healthOperatorId?: string,
    buyOrder?: string
  ) {
    const data = {
      buyOrder
    };

    return await axios
      .patch(`${this.base_url}/health-operator/update-buy-order/${healthOperatorId}`, data, {
        headers: { Authorization: `Bearer ${this.access_token()}` },
      })
      .then((result) => result)
      .catch((err) => err.response);
  }


  async updateFinalizeIntegration(healthOperatorId: string) {

    return await axios
      .patch(`${this.base_url}/health-operator/finalize-integration/${healthOperatorId}`, null, {
        headers: { Authorization: `Bearer ${this.access_token()}` },
      })
      .then((result) => result)
      .catch((err) => err.response);
  }

}

